var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinfactorProductsGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 522,
    viewBox: "0 0 522 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.7761,
    y: 256.612,
    width: 292.193,
    height: 292.193,
    rx: 32,
    transform: "rotate(-45 51.7761 256.612)",
    fill: "#F0EBFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 256.612,
    width: 268.7,
    height: 268.7,
    rx: 32,
    transform: "rotate(-45 68 256.612)",
    fill: "#D3C2FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_371_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 122.674C98 108.495 109.495 97 123.674 97H168.326C182.505 97 194 108.495 194 122.674V167.326C194 181.505 182.505 193 168.326 193H123.674C109.495 193 98 181.505 98 167.326V122.674Z",
    fill: "#B7A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108 127.326C108 116.1 117.1 107 128.326 107H163.674C174.9 107 184 116.1 184 127.326V162.674C184 173.9 174.9 183 163.674 183H128.326C117.1 183 108 173.9 108 162.674V127.326Z",
    fill: "#9A7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 131.977C118 123.705 124.705 117 132.977 117H159.023C167.295 117 174 123.705 174 131.977V158.023C174 166.295 167.295 173 159.023 173H132.977C124.705 173 118 166.295 118 158.023V131.977Z",
    fill: "#6848D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.612 157.444H134.723V132.555",
    stroke: "#B9A3FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.833 137.222L146.389 149.667L141.722 145L134.722 152",
    stroke: "#B9A3FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 97,
    width: 96,
    height: 96,
    rx: 16,
    fill: "#BAA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.678 131.839C239.357 130.634 240.633 129.889 242.015 129.889H273.642C275.025 129.889 276.301 130.634 276.98 131.839L289.045 153.243C297.416 168.095 286.156 186.104 268.498 186.104H247.16C229.502 186.104 218.242 168.095 226.613 153.243L238.678 131.839Z",
    fill: "#9679F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.67 104.575C270.357 102.231 275.689 106.304 274.661 111.442L272.819 120.652C272.192 123.786 269.441 126.042 266.245 126.042H249.391C246.315 126.042 243.634 123.948 242.887 120.964L241.811 116.659C240.366 110.878 245.602 105.642 251.383 107.087C255.368 108.083 259.578 107.621 263.252 105.784L265.67 104.575Z",
    fill: "#6848D3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.844,
    cy: 157.883,
    r: 16.6644,
    fill: "#B9A3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.175 166.321C261.483 166.041 261.651 165.691 261.679 165.271C261.707 164.85 261.567 164.486 261.259 164.178L256.597 159.264L256.639 159.138H257.059C258.571 159.138 259.824 158.676 260.818 157.752C261.812 156.828 262.421 155.75 262.645 154.518H263.359C263.639 154.518 263.87 154.42 264.052 154.224C264.234 154.028 264.325 153.79 264.325 153.51C264.325 153.23 264.234 152.999 264.052 152.817C263.87 152.635 263.639 152.544 263.359 152.544H262.603C262.519 152.124 262.372 151.725 262.162 151.347C261.952 150.969 261.693 150.598 261.385 150.234H263.359C263.639 150.234 263.87 150.136 264.052 149.94C264.234 149.744 264.325 149.506 264.325 149.226C264.325 148.946 264.234 148.715 264.052 148.533C263.87 148.351 263.639 148.26 263.359 148.26H251.599C251.263 148.26 250.976 148.379 250.738 148.617C250.499 148.855 250.38 149.142 250.38 149.478C250.38 149.814 250.499 150.094 250.738 150.318C250.976 150.542 251.263 150.654 251.599 150.654H256.933C257.661 150.654 258.256 150.836 258.718 151.2C259.18 151.564 259.495 152.012 259.663 152.544H251.347C251.067 152.544 250.836 152.642 250.654 152.838C250.471 153.034 250.38 153.272 250.38 153.552C250.38 153.832 250.471 154.063 250.654 154.245C250.836 154.427 251.067 154.518 251.347 154.518H259.705C259.537 155.078 259.215 155.561 258.739 155.967C258.263 156.373 257.619 156.576 256.807 156.576H253.951C253.587 156.576 253.272 156.66 253.006 156.828C252.74 156.996 252.537 157.234 252.397 157.542C252.257 157.85 252.215 158.165 252.271 158.487C252.327 158.809 252.481 159.11 252.733 159.39L259.033 166.279C259.313 166.587 259.663 166.741 260.083 166.741C260.503 166.741 260.867 166.601 261.175 166.321Z",
    fill: "#6848D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 97,
    width: 96,
    height: 96,
    rx: 16,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M370 185.102C392.148 185.102 410.102 167.148 410.102 145C410.102 122.852 392.148 104.898 370 104.898C347.852 104.898 329.898 122.852 329.898 145C329.898 167.148 347.852 185.102 370 185.102Z",
    fill: "#967AE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M369.999 174.789C386.452 174.789 399.789 161.452 399.789 144.999C399.789 128.547 386.452 115.209 369.999 115.209C353.547 115.209 340.209 128.547 340.209 144.999C340.209 161.452 353.547 174.789 369.999 174.789Z",
    fill: "#967AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.953 163.691C380.369 163.691 388.812 155.275 388.812 144.893C388.812 134.511 380.369 126.094 369.953 126.094C359.538 126.094 351.094 134.511 351.094 144.893C351.094 155.275 359.538 163.691 369.953 163.691Z",
    fill: "#9679F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 145.8C362.68 135.4 376.719 135.4 381.399 145.8",
    stroke: "#654CB5",
    strokeWidth: 2.16658,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7 151C367.546 151 365.8 149.254 365.8 147.1C365.8 144.946 367.546 143.2 369.7 143.2C371.854 143.2 373.6 144.946 373.6 147.1C373.6 149.254 371.854 151 369.7 151Z",
    fill: "#6848D3",
    stroke: "#5840A4",
    strokeWidth: 2.16658,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5 147C373.119 147 372 145.881 372 144.5C372 143.119 373.119 142 374.5 142C375.881 142 377 143.119 377 144.5C377 145.881 375.881 147 374.5 147Z",
    fill: "#E1D9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 209.49,
    width: 96,
    height: 95.0194,
    rx: 16,
    fill: "#7651F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 284.99V265.49C135.663 262.049 138.684 261.674 144.5 261.99C152.942 262.449 156.637 265.592 158.5 274.99C165.042 273.228 167.908 270.786 172.5 265.49C173.384 264.998 173.944 265.198 175 265.99C184.301 279.474 163.5 289.99 152 289.99C140.5 289.99 136.667 289.492 130 284.99Z",
    fill: "#C4B1FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.668 264.652C137.492 264.652 135.16 265.82 133.85 266.811C133.651 266.961 133.408 267.338 133.408 267.998V282.33C133.408 283.268 133.996 284.012 134.765 284.23C140.341 285.811 148.871 287.439 157.828 285.81C163.196 284.834 166.593 283.04 168.805 281.178C171.017 279.315 172.185 277.266 172.92 275.551C174.71 271.376 174.112 269.217 173.614 268.464C173.364 268.085 173.119 267.988 173.014 267.967C172.914 267.945 172.849 267.965 172.784 268.017C171.241 269.251 170.082 270.332 169.091 271.283C168.933 271.436 168.775 271.588 168.618 271.74C167.829 272.502 167.056 273.249 166.286 273.865C165.301 274.653 164.229 275.309 162.866 275.746C161.532 276.173 160.043 276.349 158.265 276.349H146.567C145.221 276.349 144.13 275.258 144.13 273.912C144.13 272.565 145.221 271.474 146.567 271.474H154.889C154.813 271.258 154.734 271.029 154.652 270.783C153.964 268.719 152.97 267.317 151.362 266.356C149.665 265.343 147.006 264.652 142.668 264.652ZM160.073 271.377C159.873 270.91 159.608 270.233 159.277 269.242C158.321 266.374 156.716 263.876 153.862 262.171C151.095 260.518 147.428 259.777 142.668 259.777C136.673 259.777 133.243 261.159 130.91 262.922C129.184 264.227 128.533 266.244 128.533 267.998V282.33C128.533 285.308 130.437 288.07 133.436 288.921C139.349 290.597 148.703 292.424 158.701 290.607C164.771 289.503 168.986 287.398 171.945 284.907C174.905 282.415 176.466 279.655 177.401 277.471C179.511 272.548 179.46 268.469 177.682 265.777C175.894 263.069 172.346 262.124 169.739 264.21C168.033 265.575 166.755 266.768 165.715 267.767C165.524 267.95 165.345 268.123 165.176 268.286C164.391 269.044 163.817 269.598 163.24 270.059C162.601 270.57 162.048 270.889 161.38 271.103C161.023 271.217 160.6 271.312 160.073 271.377Z",
    fill: "#9478F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.033 263.502C118.033 260.631 120.361 258.303 123.232 258.303H128.431C131.302 258.303 133.63 260.631 133.63 263.502V284.298C133.63 287.169 131.302 289.497 128.431 289.497H123.232C120.361 289.497 118.033 287.169 118.033 284.298V263.502Z",
    fill: "#563BAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.28 244.377C150.28 238.319 155.191 233.408 161.249 233.408C167.306 233.408 172.217 238.319 172.217 244.377C172.217 250.435 167.306 255.346 161.249 255.346C155.191 255.346 150.28 250.435 150.28 244.377Z",
    fill: "#A68CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.491 223.663C145.434 223.663 140.523 228.574 140.523 234.632C140.523 239.716 143.982 243.992 148.675 245.235C148.656 244.953 148.647 244.669 148.647 244.382C148.647 237.427 154.285 231.788 161.241 231.788C161.528 231.788 161.813 231.798 162.096 231.817C160.853 227.123 156.576 223.663 151.491 223.663Z",
    fill: "#A68CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 209,
    width: 96,
    height: 96,
    rx: 11.1727,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.448 238.989H244.554C241.929 238.989 239.801 241.151 239.801 243.818V275.202H232.671C230.046 275.202 227.918 273.041 227.918 270.374V231.747C227.918 229.08 230.046 226.918 232.671 226.918H270.695C273.321 226.918 275.448 229.08 275.448 231.747V238.989Z",
    fill: "#6D42FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.448 238.99H282.578C285.203 238.99 287.331 241.151 287.331 243.818V282.446C287.331 285.113 285.203 287.274 282.578 287.274H244.554C241.928 287.274 239.801 285.113 239.801 282.446V275.203H270.695C273.321 275.203 275.448 273.042 275.448 270.375V238.99Z",
    fill: "#6D42FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.049 248.026L248.697 255.495C247.827 256.379 247.827 257.812 248.697 258.696L256.049 266.164C256.919 267.048 258.329 267.048 259.2 266.164L266.551 258.696C267.422 257.812 267.422 256.379 266.551 255.495L259.2 248.026C258.329 247.143 256.919 247.143 256.049 248.026Z",
    fill: "#6D42FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 210.99,
    width: 96,
    height: 92.0194,
    rx: 16,
    fill: "#6848D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.102 297.194C392.249 297.194 410.204 279.24 410.204 257.092C410.204 234.944 392.249 216.99 370.102 216.99C347.954 216.99 330 234.944 330 257.092C330 279.24 347.954 297.194 370.102 297.194Z",
    fill: "#9A7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79 286.57C386.242 286.57 399.58 273.233 399.58 256.78C399.58 240.328 386.242 226.99 369.79 226.99C353.337 226.99 340 240.328 340 256.78C340 273.233 353.337 286.57 369.79 286.57Z",
    fill: "#B7A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.967 256.69C351.446 247.869 359.152 243.814 363.004 241.178C370.608 237.832 379.429 240.266 383.383 246.349C387.337 252.432 389.77 269.768 374.866 273.723C359.963 277.677 354.488 265.511 352.967 256.69Z",
    fill: "#9679F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.696 239.657V257.298H387.641C384.295 243.915 379.733 241.178 369.696 239.657Z",
    fill: "#B9A3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.373 238.861V242.898C358.874 245.154 354.995 250.618 354.995 257C354.995 265.399 361.713 272.208 370 272.208C376.297 272.208 381.688 268.276 383.914 262.703H387.897C385.507 270.415 378.398 276.01 370 276.01C359.641 276.01 351.244 267.499 351.244 257C351.244 248.488 356.763 241.283 364.373 238.861ZM370 237.99C380.359 237.99 388.756 246.501 388.756 257C388.756 257.642 388.725 258.276 388.663 258.901H368.124V238.084C368.741 238.022 369.367 237.99 370 237.99ZM371.875 241.91V255.099H384.889C384.042 248.22 378.663 242.768 371.875 241.91Z",
    fill: "#5233BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 321,
    width: 96,
    height: 96,
    rx: 16,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146 409.102C168.148 409.102 186.102 391.148 186.102 369C186.102 346.852 168.148 328.898 146 328.898C123.852 328.898 105.898 346.852 105.898 369C105.898 391.148 123.852 409.102 146 409.102Z",
    fill: "#967AE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.999 398.789C162.452 398.789 175.789 385.452 175.789 368.999C175.789 352.547 162.452 339.209 145.999 339.209C129.547 339.209 116.209 352.547 116.209 368.999C116.209 385.452 129.547 398.789 145.999 398.789Z",
    fill: "#967AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.953 387.691C156.369 387.691 164.812 379.275 164.812 368.893C164.812 358.511 156.369 350.094 145.953 350.094C135.538 350.094 127.094 358.511 127.094 368.893C127.094 379.275 135.538 387.691 145.953 387.691Z",
    fill: "#825DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.397 377.537H138.119C137.864 377.537 137.62 377.436 137.441 377.255C137.261 377.075 137.16 376.83 137.16 376.575V370.802C137.16 370.547 137.261 370.303 137.441 370.122C137.62 369.942 137.864 369.84 138.119 369.84H139.397C139.651 369.84 139.895 369.942 140.074 370.122C140.254 370.303 140.355 370.547 140.355 370.802V376.575C140.355 376.83 140.254 377.075 140.074 377.255C139.895 377.436 139.651 377.537 139.397 377.537Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.448 377.538H147.17C146.916 377.538 146.672 377.438 146.492 377.259C146.313 377.081 146.212 376.839 146.212 376.587V367.076C146.212 366.824 146.313 366.582 146.492 366.404C146.672 366.225 146.916 366.125 147.17 366.125H148.448C148.702 366.125 148.946 366.225 149.126 366.404C149.306 366.582 149.407 366.824 149.407 367.076V376.587C149.407 376.839 149.306 377.081 149.126 377.259C148.946 377.438 148.702 377.538 148.448 377.538Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.974 377.536H151.696C151.442 377.536 151.198 377.436 151.018 377.257C150.839 377.077 150.738 376.834 150.738 376.581V362.568C150.738 362.314 150.839 362.071 151.018 361.892C151.198 361.713 151.442 361.612 151.696 361.612H152.974C153.228 361.612 153.472 361.713 153.652 361.892C153.832 362.071 153.933 362.314 153.933 362.568V376.581C153.933 376.834 153.832 377.077 153.652 377.257C153.472 377.436 153.228 377.536 152.974 377.536Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M143.922 377.536H142.644C142.39 377.536 142.146 377.434 141.967 377.253C141.787 377.071 141.686 376.825 141.686 376.568V359.13C141.686 358.873 141.787 358.627 141.967 358.445C142.146 358.264 142.39 358.162 142.644 358.162H143.922C144.177 358.162 144.42 358.264 144.6 358.445C144.78 358.627 144.881 358.873 144.881 359.13V376.568C144.881 376.695 144.856 376.821 144.808 376.938C144.76 377.056 144.689 377.163 144.6 377.253C144.511 377.343 144.406 377.414 144.289 377.463C144.173 377.511 144.048 377.536 143.922 377.536Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 321,
    width: 96,
    height: 96,
    rx: 16,
    fill: "#825DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 351.68L257.972 346.288L275.945 351.68V388.226C262.136 394.515 254.301 394.667 240 388.226V351.68Z",
    fill: "#B9A3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.972 362.973C248.046 362.973 240 358.949 240 353.986C240 349.023 248.046 345 257.972 345C267.898 345 275.945 349.023 275.945 353.986C275.945 358.949 267.898 362.973 257.972 362.973Z",
    stroke: "#5233BA",
    strokeWidth: 5.39177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 368.365C240 373.327 248.046 377.351 257.972 377.351C267.898 377.351 275.945 373.327 275.945 368.365",
    stroke: "#5233BA",
    strokeWidth: 5.39177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 353.986V382.742C240 387.705 248.046 391.728 257.972 391.728C267.898 391.728 275.945 387.705 275.945 382.742V353.986",
    stroke: "#5233BA",
    strokeWidth: 5.39177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 321,
    width: 96,
    height: 96,
    rx: 16,
    fill: "#B9A3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.389 401.908C394.116 401.908 396.326 399.698 396.326 396.972V348.427C396.326 347.903 396.118 347.401 395.748 347.03L385.386 336.669C385.016 336.299 384.514 336.091 383.99 336.091H345.647C344.556 336.091 343.672 336.975 343.672 338.065V399.933C343.672 401.024 344.556 401.908 345.647 401.908H391.389Z",
    fill: "#9679F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.326 374.553V348.427C396.326 347.903 396.118 347.401 395.748 347.03L385.386 336.669C385.016 336.299 384.514 336.091 383.99 336.091H345.647C344.556 336.091 343.672 336.975 343.672 338.065V399.933C343.672 401.024 344.556 401.908 345.647 401.908L371.407 401.908",
    stroke: "#7C5AEC",
    strokeWidth: 3.70221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.162 336.091V347.28C383.162 348.37 384.046 349.254 385.137 349.254H396.326",
    stroke: "#7C5AEC",
    strokeWidth: 3.70221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.837 362.418H383.164M356.837 349.255H370.001M356.837 375.582H366.71",
    stroke: "#5233BA",
    strokeWidth: 3.70221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.218 393.604L379.751 395.098C379.258 395.591 378.934 396.228 378.827 396.917L378.028 402.039L383.15 401.241C383.839 401.133 384.476 400.809 384.97 400.316L386.218 399.104M381.218 393.604L386.218 399.104L381.218 393.604Z",
    fill: "#9679F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.218 393.604L392.885 381.963C394.327 380.522 396.663 380.522 398.104 381.963C399.545 383.404 399.545 385.741 398.104 387.182L386.218 399.104M381.218 393.604L386.218 399.104L381.218 393.604Z",
    fill: "#B9A3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.218 393.604L392.885 381.963C394.327 380.522 396.663 380.522 398.104 381.963C399.545 383.404 399.545 385.741 398.104 387.182L386.218 399.104M381.218 393.604L379.751 395.098C379.258 395.591 378.934 396.228 378.827 396.917L378.028 402.039L383.15 401.241C383.839 401.133 384.476 400.809 384.97 400.316L386.218 399.104M381.218 393.604L386.218 399.104",
    stroke: "#5233BA",
    strokeWidth: 2.46814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_371_1048",
    x: 0.0999985,
    y: 0.0999985,
    width: 521.8,
    height: 521.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.630795 0 0 0 0 0.459701 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_371_1048"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.609519 0 0 0 0 0.494515 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_371_1048",
    result: "effect2_dropShadow_371_1048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_371_1048",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinfactorProductsGrid);
export default __webpack_public_path__ + "static/media/finfactor-products-grid.678926597b1a5b187d1caf43a2ec88e2.svg";
export { ForwardRef as ReactComponent };